import { create } from 'zustand';
import { fetchTutorialMode, setTutorialMode } from '../lib/supabase';

/**
 * Erklärkästen an oder aus — wie im Event Manager.
 *
 * Die Einstellung hängt an der Person, nicht am Gerät: Wer im Studio den
 * Rechner wechselt, findet seine Oberfläche so wieder, wie er sie verlassen
 * hat. Standard ist „an": Wer neu dazukommt, soll die Erklärungen sehen und
 * sie bewusst abschalten müssen, nicht umgekehrt.
 */
interface TutorialStore {
  an: boolean;
  geladen: boolean;
  laden: () => Promise<void>;
  umschalten: () => Promise<void>;
}

export const useTutorialStore = create<TutorialStore>((set, get) => ({
  an: true,
  geladen: false,

  laden: async () => {
    try {
      const an = await fetchTutorialMode();
      set({ an, geladen: true });
    } catch (e) {
      // Ohne Einstellung lieber die Erklärungen zeigen als sie zu verschlucken.
      console.warn('Tutorial-Einstellung nicht ladbar:', (e as Error).message);
      set({ an: true, geladen: true });
    }
  },

  umschalten: async () => {
    const neu = !get().an;
    set({ an: neu });
    try {
      await setTutorialMode(neu);
    } catch (e) {
      // Speichern gescheitert: zurück auf den alten Stand, sonst zeigt die
      // Oberfläche etwas anderes an als beim nächsten Laden herauskommt.
      console.warn('Tutorial-Einstellung nicht speicherbar:', (e as Error).message);
      set({ an: !neu });
    }
  },
}));
